import React from 'react';
import logo from './logo.svg';
import './App.css';
import {Root} from './components/layouts/root';

function App() {
  return (
    <Root/>
  );
}

export default App;
